var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { patch, elementOpen, elementClose, text } from 'incremental-dom';
import { isNil, patchElement } from '../utils';
import { linkClick } from '../rxjs';
var transitionTime = 500;
;
var merge = function (b, n) {
    return (__assign(__assign({}, b), n));
};
var sideMenuStore = {
    show: false,
    actual: 0
};
var SideMenu = function (sidemenu) {
    var sdm = Object.create({});
    sdm.toggle = function (force, head) { return toggleSubMenu(sidemenu, force, head); };
    // dm.toggle = (force, head) => toggleSubMenu(dropmenu, sidemenu, force, head);
    sdm.reset = function () { return sideMenuStore = { show: false, actual: 0 }; };
    return sdm;
};
var formattedSideMenuContent = function (sidemenu, currentLocation) {
    elementOpen('div', null, null, 'class', 'sidemenucontent');
    if (typeof sidemenu === 'function') {
        sidemenu(currentLocation);
    }
    else {
        sidemenu.map(function (menuColumn, j) {
            elementOpen('div', null, null, 'class', 'sidemenucolumn');
            elementOpen('ul');
            menuColumn.map(function (_a, i) {
                var menuText = _a[0], link = _a[1];
                elementOpen('li');
                elementOpen('a', "smc-" + link + "-" + i, null, 'href', link, 'class', currentLocation === link ? 'active-link' : 'other-link', 'onclick', function (event) {
                    linkClick(event, link);
                });
                text(menuText);
                elementClose('a');
                elementClose('li');
            });
            elementClose('ul');
            elementClose('div');
        });
    }
    elementClose('div');
};
var toggleSubMenu = function (sidemenu, force, head) {
    // console.log(`tsm: ${sideMenuStore.show}`);
    if (head === void 0) { head = true; }
    if (isNil(force) ? !sideMenuStore.show : force) {
        // console.log('showing')
        patch(patchElement(head ? 'headsidemenu' : 'topsidemenu'), function () {
            formattedSideMenuContent(sidemenu, window.location.pathname);
            sideBaseMenuToggle(!head, true);
        });
        sideMenuStore.show = true;
    }
    else {
        sideBaseMenuToggle(!head, false);
        sideMenuStore.show = false;
    }
};
var sideMenuWrapper = function (top) {
    var menuElement = document.getElementById(top ? 'topsidemenu' : 'headsidemenu');
    return isNil(menuElement) ? document.createElement("div") : menuElement;
};
var sideMenuElement = function (top) {
    // let menuElement = Sizzle(top?'#topsidemenu .sidemenucontent':'#headsidemenu .sidemenucontent');
    // return isNil(menuElement) ? undefined : menuElement[0];
    var menuElement = document.getElementsByClassName('sidemenucontent');
    return isNil(menuElement) ? document.createElement("div") : menuElement[0];
    ;
};
var animateSideMenu = function (showX, menuWidthX, showStartX, top) {
    var menuElementX = sideMenuWrapper(top);
    if ((sideMenuStore.show !== showX) || (isNil(menuElementX))) {
        // console.log(`${showStartX} ${showX?'Showing':'Hiding'} cancelled`);
        return true; // Show/hide was cancelled or  Menu has been removed
    }
    var progress = (Date.now() - showStartX) / transitionTime;
    // console.log(`${showStartX} ${showX?'Showing':'Hiding'} progress: ${progress}`);
    if (progress < 0.99) {
        menuElementX.style.right = "-" + menuWidthX * (showX ? 1 - progress : progress) + "px";
        sideMenuStore = merge(sideMenuStore, { actual: showX ? progress : 1 - progress });
        window.requestAnimationFrame(function () { return animateSideMenu(showX, menuWidthX, showStartX, top); });
    }
    else {
        menuElementX.style.right = showX ? "0px" : "-" + menuWidthX + "px";
        sideMenuStore = merge(sideMenuStore, { actual: showX ? 1 : 0 });
        if (!showX) {
            patch(sideMenuWrapper(top), function () { });
        }
    }
};
var lastToggle;
// NICE: Use head instead of top
var sideBaseMenuToggle = function (top, force) {
    if ((Date.now() - lastToggle) < 200) { // Debounce
        return;
    }
    if (sideMenuStore.show === force) { // Exit if we are already at the force state
        return;
    }
    lastToggle = Date.now();
    // let menuWrapper = sideMenuWrapper();
    var menuElement = sideMenuElement(top);
    var menuWrapper = sideMenuWrapper(top);
    if (!isNil(menuElement)) {
        var topMenuWrapper = document.getElementById('topmenuwrapper');
        var menuHeight = top ? topMenuWrapper.offsetHeight : document.getElementById('headmenuwrapper').getBoundingClientRect().bottom;
        menuWrapper.style.height = "calc(100vh - " + menuHeight + "px)";
        menuWrapper.style.top = menuHeight + "px";
        sideMenuStore = merge(sideMenuStore, { show: !sideMenuStore.show });
        var showStart = Date.now() - (sideMenuStore.show ? sideMenuStore.actual : (1 - sideMenuStore.actual)) * transitionTime;
        var currentShow = sideMenuStore.show; // Need to fix to current scope
        animateSideMenu(currentShow, menuElement.offsetWidth, showStart, top);
    }
};
export { SideMenu };
//# sourceMappingURL=sidemenu.js.map